import type { CityConfig } from "@/pages/city-template/types";

export const lancasterNhConfig: CityConfig = {
  city: "Lancaster",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "lancaster-nh",
  route: "/cities/lancaster-nh",
  title: "Emergency & Expedited Passport Services Lancaster NH | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Lancaster, NH — as fast as 24 hours. No Lancaster passport agency. Fast Passport Center couriers to the Boston Passport Agency at Tip O'Neill Federal Building, about 195 miles south. A+ BBB rated. Serving Groveton, Jefferson, Whitefield, and all Coos County and northern Grafton County travelers heading abroad for business, adventure, or family.",
  h1: "Emergency & Expedited Passport Services in Lancaster, NH",
  heroSubtitle: "Lancaster is the county seat of Coos County in New Hampshire's Great North Woods — a historic town along the Connecticut River, known for its classic covered bridge, Weeks State Park with panoramic views of the Presidential Range, and its role as a gateway to the northern White Mountains and Canadian border. Fast Passport Center's registered couriers deliver your documents to the Boston Passport Agency at the Tip O'Neill Federal Building so you get a new or renewed passport as fast as 24 hours — whether you're a Great North Woods snowmobile tour operator heading to an international outdoor expo, a Coos County family planning a cross-border vacation into Canada, or a remote worker in the White Mountains heading abroad for the first time.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Lancaster%20New%20Hampshire%20historic%20Main%20Street%20with%20the%20Connecticut%20River%20valley%20landscape%20and%20White%20Mountains%20Presidential%20Range%20visible%20in%20the%20distance%2C%20classic%20covered%20bridge%20and%20Weeks%20State%20Park%20stone%20tower%20on%20the%20hill%2C%20New%20England%20small%20town%20charm%20during%20vibrant%20autumn%20season%2C%20wide%20angle%20landscape%20photography%20with%20golden%20late%20afternoon%20light&width=1800&height=700&seq=lancaster-nh-hero-001&orientation=landscape",
  heroImageAlt: "Lancaster New Hampshire with Connecticut River valley and Presidential Range views",
  geoPosition: "44.4889;-71.5693",
  geoPlacename: "Lancaster, New Hampshire",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "Tip O'Neill Federal Building, 10 Causeway Street, Boston, MA 02222",
    distance: "Approximately 195 miles from Lancaster — about 3 hours 15 minutes via US-3 and I-93 south",
  },
  nearbyCitiesZips: [
    { name: "Lancaster", zips: "03584" },
    { name: "Whitefield", zips: "03598" },
    { name: "Jefferson", zips: "03583" },
    { name: "Groveton", zips: "03582" },
    { name: "Littleton", zips: "03561" },
    { name: "Berlin", zips: "03570" },
    { name: "Gorham", zips: "03581" },
    { name: "Milan", zips: "03588" },
    { name: "Colebrook", zips: "03576" },
    { name: "Northumberland", zips: "03582" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Boston Passport Agency — about 195 miles from Lancaster via US-3 and I-93" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Great North Woods Service", desc: "Serving Lancaster, Groveton, Whitefield, Jefferson, and all Coos County" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Lancaster case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in New Hampshire", route: "/states/new-hampshire" },
    { name: "Expedited passport in Manchester NH", route: "/manchester" },
    { name: "Urgent passport in Lancaster NH", route: "/cities/lancaster-nh" },
    { name: "New Hampshire passport hub", route: "/states/new-hampshire" },
    { name: "Fast passport in Littleton NH", route: "/cities/littleton-nh" },
    { name: "Expedited passport in Berlin NH", route: "/cities/berlin" },
    { name: "Emergency passport in Conway NH", route: "/cities/conway-nh" },
  ],
  fpcOfficeAddress: "Tip O'Neill Federal Building, 10 Causeway Street, Boston, MA 02222",
  fpcOfficeNote: "Fast Passport Center serves Lancaster remotely via secure courier. Our registered couriers hand-deliver your documents to the Boston Passport Agency at the Tip O'Neill Federal Building — approximately 195 miles south. Lancaster's location in New Hampshire's Great North Woods makes it one of the most remote communities we serve, but overnight courier routing via I-93 from the Littleton corridor remains consistently reliable. Our dedicated agents ensure Coos County and northern White Mountains travelers never need to attempt the 3+ hour drive to Boston for passport processing.",
  fpcOfficeDistance: "Serving all of Coos County and the Great North Woods region of New Hampshire",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Lancaster, Groveton, Whitefield, Jefferson, Colebrook, and the entire Great North Woods region. From snowmobile tour operators to Coos County families heading to Canada, we help Lancaster travelers get their passports fast.",
  nearbyCitiesIntro: "We serve Lancaster and nearby communities including Whitefield, Jefferson, Groveton, Northumberland, Colebrook, and the Connecticut River Valley towns — plus Littleton just 9 miles south.",
  howItWorksIntro: "Most Lancaster travelers complete everything online and ship documents overnight. At approximately 195 miles from Boston — the farthest city we serve in New Hampshire — Fast Passport Center provides fast courier turnaround for Great North Woods residents, eliminating a 3+ hour drive through the White Mountains and I-93 corridor to Boston.",
  mistakesIntro: "Lancaster travelers, including outdoor recreation professionals and Coos County families near the Canadian border, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Lancaster and Great North Woods travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Lancaster? Here are the most common ones we hear from Coos County and Great North Woods area travelers.",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (NH Vital Records)", url: "https://www.sos.nh.gov/vital-records", desc: "New Hampshire Secretary of State — Vital Records for birth and death certificates statewide" },
    { label: "Marriage Licenses (Coos County Clerk)", url: "https://www.cooscountynh.us/", desc: "Coos County Clerk for Lancaster and Great North Woods" },
    { label: "Divorce Decrees (Coos County Superior Court)", url: "https://www.courts.state.nh.us/courts/superior.htm", desc: "Coos County Superior Court for divorce decree records" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order New Hampshire vital records online via VitalChek" },
  ],
  statePageRoute: "/states/new-hampshire",
  statePageName: "New Hampshire",
  dmvWebsite: "https://www.nh.gov/safety/divisions/dmv/index.htm",
  dmvLabel: "New Hampshire DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins at Causeway Street",
        "Life-or-death emergencies only",
        "195 miles to Boston (3 hours 15 minutes via US-3/I-93)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for outdoor recreation pros",
        "Perfect for Coos County families",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from BOS, MHT, or BTV",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Lancaster is 195 miles from the Boston Passport Agency — our courier service saves Great North Woods travelers the 3+ hour drive through the White Mountains to Boston.",
      bullets: ["Coos County coverage", "24–48 hour turnaround available", "No appointment or Boston drive needed"],
      badge: "Fastest in the Great North Woods",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Lancaster adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Lancaster and Coos County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Lancaster and Coos County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Lancaster and Great North Woods residents with DS-64 form guidance and courier routing to Boston.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Boston agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Coos County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Lancaster and Coos County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Lancaster NH", description: "Urgent passport processing for Lancaster, NH travelers via Boston Passport Agency courier — 195 miles from Lancaster." },
    { name: "Passport Renewal Lancaster NH", description: "Fast passport renewal for Lancaster and Coos County, New Hampshire residents." },
    { name: "New Passport Lancaster NH", description: "First-time passport application assistance for Lancaster and Great North Woods area residents." },
    { name: "Lost Passport Lancaster NH", description: "Passport replacement for lost or stolen passports for Lancaster and Coos County residents." },
    { name: "Child Passport Lancaster NH", description: "Minor passport services for Lancaster and Great North Woods families." },
    { name: "Name Change Passport Lancaster NH", description: "Passport name change service for Lancaster, NH residents." },
  ],
  testimonials: [
    {
      name: "Brian H.",
      location: "Lancaster, NH — Snowmobile Tour Operator",
      rating: 5,
      text: "I run guided snowmobile tours in the Great North Woods and was invited to present at an international winter tourism conference in Norway — 3 weeks notice. My passport had expired the year before and I hadn't noticed. Fast Passport Center renewed it in 6 business days. From Lancaster to Norway in less than 3 weeks — wouldn't have been possible without their courier service.",
      service: "Passport Renewal",
    },
    {
      name: "The W Family",
      location: "Whitefield, NH",
      rating: 5,
      text: "We live in Whitefield and planned a family reunion in Quebec City — just across the border but requires passports now. Two of our three kids had never had passports. Fast Passport Center processed three child first-time passports plus two adult renewals — all five in 10 business days. The Lancaster Post Office appointment was easy to schedule, and their courier handled everything to Boston.",
      service: "Family Passport Package",
    },
    {
      name: "Doris M.",
      location: "Jefferson, NH",
      rating: 5,
      text: "I'm a retired schoolteacher living in Jefferson, right near the Lancaster line. My daughter in London had a baby, and I wanted to fly out within 2 weeks. My passport was expired 3 years ago. Fast Passport Center got me a new passport in 7 business days — I was holding my granddaughter 16 days after I called them. Unbelievable service from the most remote corner of New Hampshire.",
      service: "New Passport",
    },
    {
      name: "Mark and Linda T.",
      location: "Groveton, NH",
      rating: 5,
      text: "Groveton residents planning our first-ever overseas trip — a river cruise from Amsterdam to Budapest for our 30th anniversary. Never had passports before. Walked us through the entire DS-11 process, DS-82 for Linda's name change documents, photo specs — everything. Both passports arrived in 9 business days. We're leaving next week and couldn't be more excited.",
      service: "First-Time Passports",
    },
  ],
  facilities: [
    {
      id: "lnc-1",
      name: "Lancaster Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 Main St",
      city: "Lancaster",
      state: "NH",
      zip: "03584",
      phone: "(603) 788-2762",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lancaster — Downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Lancaster and the central Great North Woods. Appointment required. Located on Main Street in downtown Lancaster.",
      icon: "ri-mail-line",
    },
    {
      id: "lnc-2",
      name: "Coos County Registry of Deeds",
      type: "County Passport Acceptance",
      address: "55 School St",
      city: "Lancaster",
      state: "NH",
      zip: "03584",
      phone: "(603) 788-2392",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Lancaster — County Complex",
      website: "https://www.cooscountynh.us",
      websiteLabel: "Coos County Government",
      notes: "County-level passport acceptance serving all Coos County residents. Located at the county complex on School Street. Often has more availability than the post office.",
      icon: "ri-government-line",
    },
    {
      id: "lnc-3",
      name: "Whitefield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 King Square",
      city: "Whitefield",
      state: "NH",
      zip: "03598",
      phone: "(603) 837-2581",
      hours: "Mon–Fri: 9:00 AM – 3:30 PM",
      distance: "Whitefield — 8 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient option for Whitefield and southern Lancaster area residents. Smaller facility — call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "lnc-4",
      name: "Littleton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "35 Cottage St",
      city: "Littleton",
      state: "NH",
      zip: "03561",
      phone: "(603) 444-3301",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Littleton — 9 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility just south of Lancaster in Littleton. More appointment slots than smaller North Country post offices.",
      icon: "ri-mail-line",
    },
    {
      id: "lnc-5",
      name: "Berlin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 Main St",
      city: "Berlin",
      state: "NH",
      zip: "03570",
      phone: "(603) 752-2480",
      hours: "Mon–Fri: 8:30 AM – 4:00 PM",
      distance: "Berlin — 25 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger North Country facility east of Lancaster. Convenient for Jefferson and Randolph area residents heading toward the Androscoggin Valley.",
      icon: "ri-mail-line",
    },
    {
      id: "lnc-6",
      name: "Colebrook Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "105 Main St",
      city: "Colebrook",
      state: "NH",
      zip: "03576",
      phone: "(603) 237-4026",
      hours: "Mon–Fri: 9:00 AM – 3:30 PM",
      distance: "Colebrook — 25 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northernmost passport acceptance facility in New Hampshire. Serves Colebrook, Pittsburg, and the Canadian border communities of Coos County.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Boston Agency", agency: "195 miles — 3 hour 15 minute drive via US-3/I-93 plus Boston traffic", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Distance to the Boston Passport Agency",
      description: "Lancaster is the farthest city we serve from the Boston Passport Agency — about 195 miles. That's a minimum 3 hour 15 minute drive through US-3 and I-93, plus navigating Boston traffic and parking near Causeway Street. Attempting a same-day round trip for emergency processing is essentially a 7+ hour commitment. Courier service eliminates this entirely.",
    },
    {
      icon: "ri-flag-line",
      title: "Not Realizing Land Border Crossing Rules Changed at the Canadian Border",
      description: "Lancaster is only about 20 miles from the Canadian border near Pittsburg and Colebrook. Many Coos County residents who previously crossed into Quebec with just an enhanced driver's license or birth certificate now need a passport or passport card for all land border crossings since the Western Hemisphere Travel Initiative was fully enforced. Old habits die hard in border communities.",
    },
    {
      icon: "ri-snowy-line",
      title: "Scheduling Passport Applications During Mud Season or Winter Whiteouts",
      description: "Lancaster-area acceptance facilities have limited hours in small-town post offices. Planning an in-person DS-11 appointment during March mud season (unpaved roads become nearly impassable) or during winter whiteout conditions risks missing the appointment — and rescheduling can take 2–4 weeks. Summer and early fall are the safest seasons for in-person appointments in the Great North Woods.",
    },
    {
      icon: "ri-global-line",
      title: "Confusing the Canadian NEXUS Card with a U.S. Passport",
      description: "Lancaster residents who frequently cross into Quebec for shopping or visiting may have a NEXUS trusted traveler card. While NEXUS allows expedited border crossing into Canada by land and air, it is NOT a substitute for a U.S. passport for international travel beyond Canada. For flights to Europe, Asia, or anywhere outside North America, a valid passport book is required.",
    },
    {
      icon: "ri-image-line",
      title: "Using Home-Printed Photos for Passport Applications",
      description: "In remote areas like Lancaster, some residents attempt to take and print passport photos at home to save a trip to a photo service. The U.S. Department of State rejects the vast majority of home-printed photos due to incorrect size, shadows, poor resolution, or non-compliant backgrounds. Always use a professional passport photo service — even if it means driving to Littleton or Berlin.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Factoring in ATV and Snowmobile Season Acceptance Facility Closures",
      description: "Coos County's economy revolves around outdoor recreation tourism — ATV season (May–October) and snowmobile season (December–March). Lancaster-area post offices and county offices sometimes reduce hours or close during major events like the Jericho ATV Festival or when staff are redirected. Always confirm passport acceptance facility hours directly before planning an appointment.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Lancaster, Littleton, or Berlin." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Boston Passport Agency — 195 miles south via US-3 and I-93." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Boston Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Lancaster or Great North Woods address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Lancaster from the Boston passport agency?",
      a: "Lancaster is approximately 195 miles from the Boston Passport Agency — about a 3 hour 15 minute drive south via US-3 to I-93 through Franconia Notch, past Plymouth, Concord, and Manchester, then into Boston. This makes Lancaster the most distant city we serve in New Hampshire from the Boston agency. The agency requires pre-scheduled NPIC appointments and does not accept walk-ins.",
    },
    {
      q: "Is there any passport agency closer to Lancaster than Boston?",
      a: "No. There is no passport agency anywhere in New Hampshire, Vermont, or Maine. The closest passport agency to Lancaster is the Boston Passport Agency at the Tip O'Neill Federal Building — about 195 miles south. The National Passport Center in Portsmouth is slightly closer at about 170 miles but is not a public-facing agency — it's a processing facility only.",
    },
    {
      q: "How do I get a passport in Lancaster without driving to Boston?",
      a: "Fast Passport Center's registered courier service is the most practical option for Lancaster residents. Complete the online application, ship documents via overnight courier (pickup available in Lancaster, Littleton, or Berlin), and we hand-deliver to the Boston Passport Agency. Your new passport arrives via overnight delivery — eliminating the 195-mile, 3+ hour drive each way.",
    },
    {
      q: "Does the Lancaster NH Post Office process passport applications?",
      a: "Yes. The Lancaster Post Office at 120 Main St is a passport acceptance facility. They accept DS-11 applications and verify identity documents. Call (603) 788-2762 for an appointment. The Coos County Registry of Deeds at 55 School St in Lancaster also accepts passport applications — often with more appointment availability and slightly longer hours.",
    },
    {
      q: "I live near the Canadian border — do I need a passport to visit Quebec?",
      a: "Yes. Land border crossings between the U.S. and Canada now require a valid passport book, passport card, or enhanced driver's license (EDL) for all travelers, including children. A standard New Hampshire driver's license is not sufficient. If you cross regularly from the Pittsburg/Colebrook area into Quebec, consider the passport card for land crossings — it's cheaper than a passport book but cannot be used for air travel.",
    },
    {
      q: "How fast can I get an emergency passport in Lancaster?",
      a: "Emergency processing for Lancaster residents is typically 24–48 hours via courier to Boston. The Great North Woods' remote location does not affect courier speed — I-93 is a maintained priority route and overnight shipping from the Littleton/Lancaster corridor to Boston is reliable year-round. Standard expedited processing runs 2–9 business days.",
    },
    {
      q: "Where can I get passport photos in Lancaster?",
      a: "Photo services in Lancaster are limited. The closest reliable options are Rite Aid in Littleton (545 Meadow St, about 9 miles south) and Walgreens in St. Johnsbury, VT (24 Railroad St, about 20 miles northwest). Some smaller pharmacies in Lancaster may offer the service — call ahead to confirm they follow current U.S. Department of State photo specifications.",
    },
    {
      q: "Does winter weather in the Great North Woods prevent courier service?",
      a: "Winter in Coos County is severe, with Lancaster regularly seeing temperatures well below zero and heavy snowfall. However, overnight courier services to Boston via US-3 and I-93 operate reliably year-round. The route through Franconia Notch is maintained as a priority state highway. We track weather and adjust as needed — but delays are extremely rare.",
    },
    {
      q: "Can Fast Passport Center help Groveton and Colebrook residents too?",
      a: "Absolutely. We serve the entire Great North Woods including Lancaster, Groveton (8 miles west), Whitefield (8 miles south), Jefferson (9 miles east), Colebrook (25 miles north at the Canadian border), Berlin (25 miles east), and all Coos County communities. Document pickup is available throughout the region.",
    },
    {
      q: "I'm a snowmobile tour operator — how early should I start passport prep for international industry events?",
      a: "Great North Woods outdoor recreation professionals should start passport preparation at least 3 months before any international industry event or trade show. Events like international snowmobile expos and winter tourism conferences often require visas for non-North American destinations, which add weeks to the timeline. Fast Passport Center's 2–9 business day courier service handles the passport portion — but the full passport-plus-visa pipeline needs headroom.",
    },
    {
      q: "Which airports do Lancaster travelers use for international flights?",
      a: "Lancaster travelers typically fly from Burlington International Airport (BTV, about 85 miles west), Manchester-Boston Regional Airport (MHT, about 120 miles south), Boston Logan International Airport (BOS, about 195 miles south), or Montreal-Pierre Elliott Trudeau International Airport (YUL, about 140 miles northwest across the Canadian border). BOS offers the most direct international routes.",
    },
    {
      q: "What's the difference between the Coos County Registry and the Lancaster Post Office for passport acceptance?",
      a: "Both the Coos County Registry of Deeds at 55 School St and the Lancaster Post Office at 120 Main St accept passport applications. The County Registry typically has more appointment availability and slightly longer hours (8 AM–4 PM vs 9 AM–4 PM). Neither facility can expedite processing — they simply accept and forward applications. For fast processing, Fast Passport Center's courier service handles the expediting after acceptance.",
    },
  ],
  photoLocations: [
    { name: "Rite Aid — Littleton", address: "545 Meadow St, Littleton, NH 03561", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Walgreens — St. Johnsbury VT", address: "24 Railroad St, St. Johnsbury, VT 05819", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Walmart Photo — Woodsville", address: "11 Church St, Woodsville, NH 03785", hours: "Mon–Sun: 7AM–9PM" },
    { name: "CVS Pharmacy — Berlin", address: "4 Main St, Berlin, NH 03570", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Plymouth", address: "24 Main St, Plymouth, NH 03264", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM" },
    { name: "FedEx Office — Concord", address: "67 Fort Eddy Rd, Concord, NH 03301", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "NH DMV — Twin Mountain", address: "549 Route 302, Twin Mountain, NH 03595", hours: "Mon–Fri: 8:00AM–4:30PM", note: "Closest DMV to Lancaster — about 18 miles south in Twin Mountain. REAL ID, driver's license, and state ID services for Coos County residents.", featured: true },
    { name: "NH DMV — Concord", address: "23 Hazen Dr, Concord, NH 03301", hours: "Mon–Fri: 8:00AM–4:30PM", note: "State headquarters DMV with full services. About 120 miles south of Lancaster.", featured: false },
    { name: "NH DMV — Plymouth", address: "271 Main St, Plymouth, NH 03264", hours: "Mon–Fri: 8:00AM–4:30PM", note: "Mid-way DMV option about 70 miles south of Lancaster in the Plymouth area.", featured: false },
  ],
  airports: [
    {
      code: "BTV",
      name: "Burlington International Airport",
      distance: "85 miles west of Lancaster",
      address: "1200 Airport Dr, South Burlington, VT 05403",
      note: "Closest commercial airport to Lancaster with domestic routes. About 1 hour 45 minutes via US-2 and I-89. Convenient for Coos County and Northeast Kingdom travelers.",
      flightUrl: "https://www.btv.aero/",
      flightLabel: "BTV Airport",
      featured: true,
    },
    {
      code: "YUL",
      name: "Montreal-Pierre Elliott Trudeau International Airport",
      distance: "140 miles northwest of Lancaster",
      address: "975 Romeo-Vachon Blvd N, Dorval, QC H4Y 1H1, Canada",
      note: "Major international hub just across the Canadian border. Requires valid passport for border crossing. About 2 hours 30 minutes via US-3 and Canadian highways.",
      flightUrl: "https://www.admtl.com/",
      flightLabel: "YUL Airport",
      featured: false,
    },
    {
      code: "MHT",
      name: "Manchester-Boston Regional Airport",
      distance: "120 miles south of Lancaster",
      address: "1 Airport Rd, Manchester, NH 03103",
      note: "New Hampshire's largest airport with domestic routes. About 2 hours 15 minutes via I-93 south.",
      flightUrl: "https://www.flymanchester.com/",
      flightLabel: "MHT Airport",
      featured: false,
    },
    {
      code: "BOS",
      name: "Boston Logan International Airport",
      distance: "195 miles south of Lancaster",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "New England's largest international gateway with direct flights worldwide. About 3 hours 15 minutes via I-93. Co-located with Boston Passport Agency.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "BOS Airport",
      featured: false,
    },
  ],
};